export default "__VITE_ASSET__BmRWBUml__"